import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import { AvForm } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  CardTitle,
  Progress,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import exportFromJSON from "export-from-json";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";

const FoodCostAndTargetAchievementReport = (props) => {
const { SearchBar } = Search;
  const [monthYear, setMonthYear] = useState();
    const [allOrders, setAllOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [allBranches, setAllBranches] = useState([]);
      const [progress, setProgress] = useState(0);
      const BATCH_SIZE = 8;
  const [currentMonthYear, setCurrentMonthYear] = useState();
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

    useEffect(() => {
      loadAllBranchCategories();
      loadAllBranches();
      setMonthYear(moment().format('YYYY-MM'));
      setCurrentMonthYear(moment().format('YYYY-MM'));
    }, []);

  const [allBranchCategories, setAllBranchCategories] = useState([]);
  const loadAllBranchCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "branchcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllBranchCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
    const calculateProductCOGS = (row) => {
        const cogs =
          Number(row.product_cost_opening ? row.product_cost_opening : 0) +
          Number(row.product_purchase_cost) +
          Number(row.product_inbound_transfer_cost) -
          Number(row.product_outbound_transfer_cost) -
          Number(row.product_cost);
        
        return isNaN(cogs) ? 0 : cogs;
      };
 const calculateUsedItemCost = (row) => {
        const cogs =
          Number(row.item_cost_opening ? row.item_cost_opening : 0) +
          Number(row.item_purchase_cost) +
          // Number(row.free_items_cost) +
          Number(row.supplier_return_credit_cost) +
          Number(row.item_inbound_transfer_cost) -
          Number(row.item_outbound_transfer_cost) -
          Number(row.item_cost);
        
        return isNaN(cogs) ? 0 : cogs;
      };

      const getReorderedMonths = (selectedMonth) => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  
  if (!selectedMonth) return months;
  
  const selectedMonthIndex = moment(selectedMonth).month();
  const beforeMonths = months.slice(0, selectedMonthIndex);
  const afterMonths = months.slice(selectedMonthIndex);
  
  return [...afterMonths,];
};
    const columns = [
        {
        dataField: "id",
        hidden: true,
        },
        {
        dataField: "_id",
            formatter: (cell, row, rowIndex) => {
                return rowIndex + 1;
            },
        text: props.t("#"),
        headerStyle: (colum, colIndex) => {
            return { width: "3%" };
        },
        editable: false,
        },
    {
        dataField: "name",
        text: props.t("Branch Name"),
        headerStyle: { width: "18%" },
        editable: false,
        },
        {
        dataField: "itemCost",
        text: props.t("Used Items"),
         sortFunc: (a, b, order, dataField, rowA, rowB) => {    
            const cogsA = calculateUsedItemCost(rowA);
            const cogsB = calculateUsedItemCost(rowB);
        
            if (order === 'asc') {
              return cogsA - cogsB;
            }
            return cogsB - cogsA;
          },
          formatter: (cell, row, rowIndex) => {
            return calculateUsedItemCost(row) ? calculateUsedItemCost(row).toFixed(2) : "0.00";
          },
        headerStyle: { width: "6%" },
        editable: false,
        },
        {
        dataField: "productCost",
        text: props.t("Used Products"),
         sortFunc: (a, b, order, dataField, rowA, rowB) => {
         const cogsA = calculateProductCOGS(rowA);
         const cogsB = calculateProductCOGS(rowB);
     
         if (order === 'asc') {
           return cogsA - cogsB;
         }
         return cogsB - cogsA;
       },
       headerStyle: (colum, colIndex) => {
         return { width: "8%" };
       },
       formatter: (cell, row, rowIndex) => {
         let cogs =calculateProductCOGS(row)
 
         if (isNaN(cogs)) {
           cogs = "0.00";
         } else {
           cogs = cogs.toFixed(2);
         }
         return cogs;
       },
        headerStyle: { width: "5%" },
        editable: false,
        },
         ...getReorderedMonths(monthYear).map((m) => ({
        dataField: `${m.toLowerCase()}FoodCost`,
        text: `${m} Food Cost %`,
    //      headerStyle: { 
    //   minWidth: "100px", 
    //   fontSize: "11px", 
    //   textAlign: "center",
    //   backgroundColor: m === moment(monthYear).format('MMM') ? '#e6f3ff' : 'inherit'
    // },
    //  style: (cell, row) => ({
    //   backgroundColor: m === moment(monthYear).format('MMM') ? '#e6f3ff' : 'inherit',
    //   textAlign: 'right'
    // }),
        headerStyle: { minWidth: "100px", fontSize: "11px", textAlign:"center" },
       formatter: (cell, row) => {
      // Your existing formatter logic
      return cell || "";
    },
        editable: false,
        })),
    ];

const loadAllBranches = async () => {
   try {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, {
      catalog_only: true,
      type: "Branch",
      is_active: true,
    });
    if (response.status === 1) {
      const res = (response.data || []).filter(
        (store) => store.type === "Branch" && store.is_active === true
      );
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.error(error)
   }
  };

const loadOrders = async () => {
  const requestId = ++ordersRequestId.current;
  try {
    if (!allBranches.length) {
      showNotification("Branches are still loading. Please try again.", "Error");
      return;
    }

    setIsLoading(true);
    setProgress(0);
    setAllOrders([]);
    setFilteredData([]);
    setSelectedBranchCategory('all');
    setTablePage(1);

    const branchIds = allBranches.map(branch => branch._id);
    const totalBatches = Math.ceil(branchIds.length / BATCH_SIZE) || 1;
    const storeById = new Map(allBranches.map((branch) => [String(branch._id), branch]));
    const itemsUrl = process.env.REACT_APP_BASEURL + "reports/cost_of_goods_sold_items_report";
    const productsUrl = process.env.REACT_APP_BASEURL + "reports/cost_of_goods_sold_products_report";
    let mergedData = [];

    for (let i = 0; i < branchIds.length; i += BATCH_SIZE) {
      if (requestId !== ordersRequestId.current) return;

      const payload = {
        monthYear: monthYear,
        branch_ids: branchIds.slice(i, i + BATCH_SIZE),
        summary_only: true,
      };

      try {
        const [batchResponse, batchResponse2] = await Promise.all([
          postSubmitForm(itemsUrl, payload),
          postSubmitForm(productsUrl, payload),
        ]);
        if (requestId !== ordersRequestId.current) return;

        if (batchResponse && batchResponse.status === 1 && batchResponse2 && batchResponse2.status === 1) {
          const mergedBranchData = mergeBranchData(
            batchResponse.data.branches || [],
            batchResponse2.data.branches || [],
            storeById
          );
          mergedData = mergedData.concat(mergedBranchData);
          setAllOrders(mergedData);
        } else {
          const errorMsg = batchResponse?.message || batchResponse2?.message || "API call failed";
          console.error(`Batch ${i / BATCH_SIZE + 1} failed:`, errorMsg);
        }
      } catch (batchError) {
        console.error(`Error processing batch ${i / BATCH_SIZE + 1}:`, batchError);
      }

      setProgress(Math.round(((Math.floor(i / BATCH_SIZE) + 1) / totalBatches) * 100));
    }
  } catch (error) {
    console.error("Error loading orders:", error);
    showNotification("Error loading data", "Error");
  } finally {
    if (requestId === ordersRequestId.current) {
      setIsLoading(false);
    }
  }
};

const pickMonthFields = (row) => {
  if (!row) return {};
  const out = {};
  for (const key of Object.keys(row)) {
    if (/foodcost$/i.test(key) || /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i.test(key)) {
      out[key] = row[key];
    }
  }
  return out;
};

const slimBranchRow = (itemsBranch, productsBranch, store) => {
  const source = productsBranch || itemsBranch || {};
  const itemSource = itemsBranch || {};
  const productSource = productsBranch || {};
  return {
    _id: itemSource._id || productSource._id,
    name: store?.name || itemSource.name || productSource.name,
    type: store?.type || itemSource.type || productSource.type,
    branch_category: store?.branch_category || itemSource.branch_category || productSource.branch_category,
    item_cost_opening: itemSource.item_cost_opening,
    item_purchase_cost: itemSource.item_purchase_cost,
    supplier_return_credit_cost: itemSource.supplier_return_credit_cost,
    item_inbound_transfer_cost: itemSource.item_inbound_transfer_cost,
    item_outbound_transfer_cost: itemSource.item_outbound_transfer_cost,
    item_cost: itemSource.item_cost,
    product_cost_opening: productSource.product_cost_opening,
    product_purchase_cost: productSource.product_purchase_cost,
    product_inbound_transfer_cost: productSource.product_inbound_transfer_cost,
    product_outbound_transfer_cost: productSource.product_outbound_transfer_cost,
    product_cost: productSource.product_cost,
    ...pickMonthFields(itemSource),
    ...pickMonthFields(productSource),
    ...pickMonthFields(source),
    ...pickMonthFields(store),
  };
};

const mergeBranchData = (itemsBranchData, productsBranchData, storeById) => {
  const productsMap = new Map();
  productsBranchData.forEach(branch => {
    productsMap.set(String(branch._id), branch);
  });

  const mergedData = itemsBranchData.map(itemsBranch => {
    const id = String(itemsBranch._id);
    return slimBranchRow(itemsBranch, productsMap.get(id), storeById.get(id));
  });

  productsBranchData.forEach(productsBranch => {
    const id = String(productsBranch._id);
    const existsInItems = itemsBranchData.some(itemsBranch => String(itemsBranch._id) === id);
    if (!existsInItems) {
      mergedData.push(slimBranchRow(null, productsBranch, storeById.get(id)));
    }
  });

  return mergedData;
};


    function printDiv(divName) {
    let printContents = document.getElementById(divName);
    let searchelement = printContents.getElementsByClassName("sr-only");
    if (searchelement && searchelement[0]?.parentNode) {
        searchelement[0].parentNode.removeChild(searchelement[0]);
    }
    var winPrint = window.open(
        "",
        "",
        "left=0,top=0,toolbar=0,scrollbars=1,status=0"
    );
    winPrint.document.write(
        `<title>${divName}</title>
        <head>
        <style>
            @page {  margin: 10mm; }
            body {
            margin: 2mm;
            font-size: 10px !important;
            }
            #${divName}, #${divName} * { visibility: visible; }
            #${divName} {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            font-size: 10px !important;
            overflow: visible !important;
            }
            table, th, td {
            font-size: 10px !important;
            }
            .btn, .search-bar, .no-print { display: none !important; }
            /* Hide react-bootstrap-table controls */
            .sr-only,
            .react-bootstrap-table-pagination,
            .react-bootstrap-table-filter-wrapper,
            .search-label,
            .select-filter,
            .custom-select,
            [class*="toolbar"],
            .react-bootstrap-table-pagination-list,
            .react-bootstrap-table-pagination-total,
            .text-filter,
            .text-filter-column,
            .filter-label,
            [class*="filter"],
            .react-bootstrap-table-search,
            .react-bootstrap-table-search-input {
            display: none !important;
            }
            /* Remove extra padding/margins from table */
            .react-bootstrap-table {
            margin: 0 !important;
            padding: 0 !important;
            }
            /* Ensure table takes full width */
            .table-responsive {
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: visible !important;
            }
            table {
            table-layout: fixed;
            font-family: "Poppins", sans-serif;
            border: 1px solid #eff2f7;
            font-size: 10px;
            border-collapse: collapse;
            width: 100% !important;
            max-width: 100%;
            color: #495057;
            margin-bottom: 1rem;
            margin-top: 1rem;
            }
            .d-print-none {
            display: none !important;
            }
            table td, table th {
            border: 1px solid #ddd;
            padding: 6px;
            }
            table tr:nth-child(even){background-color: #f2f2f2;}
            table tr:hover {background-color: #ddd;}
            table th {
            text-align: left;
            font-size: 10px !important;
            }
        </style>
        </head>
        <body>
        ${printContents.innerHTML}
        </body>
        `
    );
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    // winPrint.close();
    }

    const handleDownload = () => {
    const fileName = `food_consumption_report_${monthYear} ${selectedBranchCategory !== "all" ? `(${selectedBranchCategory})`: '' }`;
    const exportType = "xls";
 const orderedMonths = getReorderedMonths(monthYear);
    const exportData = filteredData.map((row, idx) => {
        let rowObj = {
        "#": idx + 1,
        "Branch Name": row.name,
        "Used Products":  calculateProductCOGS(row) ? calculateProductCOGS(row).toFixed(2) : "0.00",
        "Used Items":  calculateUsedItemCost(row) ? calculateUsedItemCost(row).toFixed(2) : "0.00",
        };
        orderedMonths.forEach(m => {
        rowObj[`${m} Food Cost %`] = row[`${m.toLowerCase()}`] || "";
        });
        return rowObj;
    });

    exportFromJSON({ data: exportData, fileName, exportType });
    };

    const [selectedBranchCategory, setSelectedBranchCategory] = useState('all');
    const [filteredData, setFilteredData] = useState([]);

    useEffect(()=>{
      if (selectedBranchCategory === 'all') {
        setFilteredData(allOrders);
      } else {
        setFilteredData(allOrders.filter(item => item.branch_category === selectedBranchCategory));
      }
    },[allOrders, selectedBranchCategory])

    const handleBranchCategoryChange = (category) => {      
      setSelectedBranchCategory(category);
      setTablePage(1);
      if (category === 'all') {
        setFilteredData(allOrders);
      } else {
        const filtered = allOrders.filter(item => item.branch_category === category);
        setFilteredData(filtered);
      }
    };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Branch Food Cost & Target Achievement Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Branch Food Cost & Target Achievement Report")}
          />
           <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                <AvForm>
                  <Row className="align-items-center">
                    <Col lg={3} sm={3}>
                      <input
                        type="month"
                        name="monthYear"
                        label={props.t("Month-Year")}
                        value={monthYear}
                        onChange={(e, v) => {
                          setMonthYear(e.target.value);
                        }}
                        max={currentMonthYear}
                        className="is-touched is-pristine av-valid form-control"
                      />
                    </Col>
                   
            <Col lg={3}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-1"
                          disabled={isLoading}
                          onClick={() => {
                            if (monthYear) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
            </Col>
            <Col lg={6}>
            <div className="d-flex justify-content-end align-items-center">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary mr-2"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      <Link
                        to="#"
                        onClick={() => printDiv(`Branch Food Cost & Target Achievement Report ${selectedBranchCategory !== "all" ? `(${selectedBranchCategory})` : '' }`)}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                    </div>
            </Col>
          </Row>
        </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
           <Row lg={12}>
           
            <Col className="col-12">
              <Card>
                <CardBody>
                   {isLoading && 
                          <div className="mb-3">
                          <Progress
                            animated
                            color="info"
                            value={progress}
                            style={{ height: '20px',color:"Highlight",fontWeight:"bold" }}
                          >
                             <div 
        style={{ 
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#000',
          fontWeight: 'bold',
          width: '100%',
          textAlign: 'center'
        }}
      >
        {Math.round(progress)}% Loading...
      </div>
                          </Progress>
                        </div>
                          }
                  <div id={`Branch Food Cost & Target Achievement Report ${selectedBranchCategory !== "all" ? `(${selectedBranchCategory})` : '' }`}>
                   
                    <ToolkitProvider
                      keyField="_id"
                      data={filteredData}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(tprops) => (
                        <div>
                          <Row>
                            <Col lg={3}>
                              <SearchBar
                                {...tprops.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={6}> <CardTitle className="text-center">
                      {("Branch Food Cost & Target Achievement Report ")}{selectedBranchCategory !== "all" && `(${selectedBranchCategory})`}
                    </CardTitle>
                    </Col>
                     <Col lg={3} sm={3} className="d-flex justify-content-end d-print-none">
                        <select
                          className="form-control w-50"
                          value={selectedBranchCategory}
                          disabled={isLoading}
                          onChange={(e) => handleBranchCategoryChange(e.target.value)}
                        >
                          <option value="all">{props.t("All")}</option>
                          {allBranchCategories.map((category) => (
                            <option key={category._id} value={category.name}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoading ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...tprops.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(FoodCostAndTargetAchievementReport))
);
